export default "__VITE_ASSET__50475529__"